(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/draws/assets/javascripts/constants.js') >= 0) return;  svs.modules.push('/components/numbergames/draws/assets/javascripts/constants.js');

'use strict';


const DRAW_STATES = {
  DEFINED: 1,
  OPEN: 2,
  CLOSED: 3
};
const PRODUCT_JUPITER_VERSION_MAPPING = {
  eurojackpot: 2,
  eurojackpottuesday: 2,
  eurojackpotfriday: 2,
  keno: 1,
  lotto: 1,
  lottowednesday: 1,
  lottosaturday: 1,
  vikinglotto: 1,
  jokerwednesday: 1,
  jokersaturday: 1
};
const PRODUCT_TO_PRODUCT_DRAW_ID_MAPPING = {
  eurojackpot: 'eurojackpot',
  eurojackpottuesday: 'eurojackpot',
  eurojackpotfriday: 'eurojackpot',
  keno: 'keno',
  lotto: 'lotto',
  lottowednesday: 'lotto',
  lottosaturday: 'lotto',
  vikinglotto: 'vikinglotto',
  jokerwednesday: 'jokerwednesday',
  jokersaturday: 'jokersaturday'
};
if (svs.isServer) {
  module.exports = {
    DRAW_STATES,
    PRODUCT_JUPITER_VERSION_MAPPING,
    PRODUCT_TO_PRODUCT_DRAW_ID_MAPPING
  };
} else {
  svs.numbergames.draws.constants = {
    DRAW_STATES,
    PRODUCT_JUPITER_VERSION_MAPPING,
    PRODUCT_TO_PRODUCT_DRAW_ID_MAPPING
  };
}

 })(window);